module.exports = __webpack_public_path__ + "img/fig5.2975bff3.png";